export interface PendoVisitor {
  id: string;
  email: string;
  full_name: string;
  role: string;
}

export interface PendoAccount {
  id: string;
  name: string;
}

declare global {
  interface Window {
    pendo?: {
      initialize: (options: { visitor: PendoVisitor; account: PendoAccount }) => void;
    };
  }
}

export const initializePendo = (visitor: PendoVisitor, account: PendoAccount): void => {
  window.pendo?.initialize({ visitor, account });
};
